import { api, saveAuthTokens } from './api';

function bufToB64url(buf) {
  let s = '';
  const bytes = new Uint8Array(buf);
  for (let i = 0; i < bytes.length; i++) s += String.fromCharCode(bytes[i]);
  return btoa(s).replace(/\+/g, '-').replace(/\//g, '_').replace(/=+$/g, '');
}

function b64urlToBuf(s) {
  const pad = '='.repeat((4 - (s.length % 4)) % 4);
  const b64 = (s + pad).replace(/-/g, '+').replace(/_/g, '/');
  const bin = atob(b64);
  const bytes = new Uint8Array(bin.length);
  for (let i = 0; i < bin.length; i++) bytes[i] = bin.charCodeAt(i);
  return bytes.buffer;
}

const creationJSON = (c) => ({
  id: c.id,
  rawId: bufToB64url(c.rawId),
  type: c.type,
  response: {
    clientDataJSON: bufToB64url(c.response.clientDataJSON),
    attestationObject: bufToB64url(c.response.attestationObject),
    transports: c.response.getTransports ? c.response.getTransports() : [],
  },
  clientExtensionResults: c.getClientExtensionResults(),
});

const assertionJSON = (c) => ({
  id: c.id,
  rawId: bufToB64url(c.rawId),
  type: c.type,
  response: {
    clientDataJSON: bufToB64url(c.response.clientDataJSON),
    authenticatorData: bufToB64url(c.response.authenticatorData),
    signature: bufToB64url(c.response.signature),
    userHandle: c.response.userHandle ? bufToB64url(c.response.userHandle) : null,
  },
  clientExtensionResults: c.getClientExtensionResults(),
});

export const passkeySupported = () =>
  typeof window !== 'undefined' && !!window.PublicKeyCredential && !!navigator.credentials;

export async function registerPasskey(name = 'Passkey') {
  const { data: opts } = await api.post('/auth/passkeys/register/options');
  opts.challenge = b64urlToBuf(opts.challenge);
  opts.user.id = b64urlToBuf(opts.user.id);
  opts.excludeCredentials = (opts.excludeCredentials || []).map((x) => ({ ...x, id: b64urlToBuf(x.id) }));
  const cred = await navigator.credentials.create({ publicKey: opts });
  if (!cred) throw new Error('Passkey registration cancelled');
  await api.post('/auth/passkeys/register/verify', { credential: creationJSON(cred), name });
}

export async function loginWithPasskey(email) {
  const { data: opts } = await api.post('/auth/passkeys/login/options', { email: email || null });
  opts.challenge = b64urlToBuf(opts.challenge);
  if (opts.allowCredentials) opts.allowCredentials = opts.allowCredentials.map((x) => ({ ...x, id: b64urlToBuf(x.id) }));
  const cred = await navigator.credentials.get({ publicKey: opts });
  if (!cred) throw new Error('Passkey sign-in cancelled');
  const { data } = await api.post('/auth/passkeys/login/verify', { credential: assertionJSON(cred) });
  saveAuthTokens(data);
  return data; // { ok } or { mfa_required }
}
